export const GiftCardTransactionType = {
  TOP_UP: "TOP_UP",
  REDEEM: "REDEMPTION",
} as const
